import "./lib/silenceConsole";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";

// Note: www.garu.ai is the canonical domain (Vercel domain settings handle redirect)
// OAuth is configured to work with www.garu.ai

console.info("App mounting: initializing root and providers");

// Run connection diagnostics in development
if (import.meta.env.DEV) {
  import("./lib/connectionDiagnostics").then(({ runDiagnostics }) => {
    runDiagnostics().catch(console.error);
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Register service worker for caching and offline support (only in production)
if (typeof window !== 'undefined') {
  import("./lib/serviceWorkerRegistration").then((sw) => {
    sw.register({
      onSuccess: () => {
        console.log('✅ App is cached for offline use');
      },
      onUpdate: () => {
        console.log('🆕 New version available! Reload to update.');
      },
    });
  }).catch((err) => {
    console.debug('Service Worker not available:', err);
  });
}
